import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import IconButton from 'components/common/IconButton';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';

const ContactsHeader = ({ handleShow, handleDetailsUpdate, setTypeLignes, lignesLoading }) => {
  const [selectionType, setSelectedType] = useState('Séparées');
  const [selectionValide, setSelectedValide] = useState(false);
  const { getSelectedRowModel } = useAdvanceTableContext();

  useEffect(() => {
    const rows = getSelectedRowModel().rows;

    // Check if all selected rows have the same client
    const isValid =
      (rows.length <= 1 && !rows[0]?.original.factass) ||
      rows.every(
        row =>
          row.original.client === rows[0].original.client &&
          !row.original.factass &&
          row.original.magasin === rows[0].original.magasin &&
          row.original.numfacture === rows[0].original.numfacture
      );

    setSelectedValide(isValid);
  }, [getSelectedRowModel().rows]);

  return (
    <div className="d-lg-flex justify-content-between">
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Liste des Transactions</h6>
        </Col>
        <Col xs="auto">
          <AdvanceTableSearchBox className="input-search-width" placeholder="Rechercher" />
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <IconButton
          variant="falcon-default"
          size="sm"
          icon="filter"
          transform="shrink-4"
          iconAlign="middle"
          className="mx-2"
          onClick={handleShow}
        >
          <span className="d-none d-sm-inline-block ms-1">Filter</span>
        </IconButton>
        <div
          className="bg-300 mx-3 d-none d-lg-block d-xl-none"
          style={{ width: '1px', height: '29px' }}
        ></div>
        {
          getSelectedRowModel().rows.length > 0 && (
            <div className="d-flex">
              <Form.Select
                size="sm"
                aria-label="Bulk actions"
                onChange={e => setSelectedType(e.target.value)}
                value={selectionType}
                disabled
              >
                <option value="Groupées">Groupées</option>
                <option value="Séparées">Séparées</option>
              </Form.Select>
              <IconButton
                variant="falcon-default"
                size="sm"
                icon="arrow-down"
                transform="shrink-3"
                className="mx-2 d-flex align-items-center"
                onClick={() => {
                  setTypeLignes(selectionType);
                  handleDetailsUpdate();
                }}
                disabled={!selectionValide}
              >
                {lignesLoading && <span className="spinner-border spinner-border-sm"></span>}
                <span className="d-inline-block">Récupérer</span>
              </IconButton>
            </div>
          )
          // : (
          //   <div id="orders-actions">
          //     <IconButton
          //       variant="falcon-default"
          //       size="sm"
          //       icon="plus"
          //       transform="shrink-3"
          //       iconAlign="middle"
          //     >
          //       <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
          //         New
          //       </span>
          //     </IconButton>
          //     <IconButton
          //       variant="falcon-default"
          //       size="sm"
          //       icon="external-link-alt"
          //       transform="shrink-3"
          //       className="mx-2"
          //       iconAlign="middle"
          //     >
          //       <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
          //         Export
          //       </span>
          //     </IconButton>
          //     <IconButton
          //       variant="falcon-default"
          //       size="sm"
          //       icon="file-import"
          //       transform="shrink-3"
          //       className="me-2"
          //       iconAlign="middle"
          //     >
          //       <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
          //         Import
          //       </span>
          //     </IconButton>
          //     <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
          //       <Dropdown.Toggle split variant="falcon-default" size="sm">
          //         <FontAwesomeIcon icon="ellipsis-h" className="fs-11" />
          //       </Dropdown.Toggle>

          //       <Dropdown.Menu className="border py-0">
          //         <div className="py-2">
          //           <Dropdown.Item>View</Dropdown.Item>
          //           <Dropdown.Item>Export</Dropdown.Item>
          //           <Dropdown.Divider />
          //           <Dropdown.Item className="text-danger">Remove</Dropdown.Item>
          //         </div>
          //       </Dropdown.Menu>
          //     </Dropdown>
          //   </div>
          // )
        }
      </div>
    </div>
  );
};

ContactsHeader.propTypes = {
  handleShow: PropTypes.func,
  handleDetailsUpdate: PropTypes.func,
  setTypeLignes: PropTypes.func,
};

export default ContactsHeader;
